import React from 'react'
import RouteNotFound from '../RouteNotFound'

const Unauthorized = () => {
  return (
    <RouteNotFound
      title="Access denied"
      description="You are not allowed to access the OLI Community Dashboard. Please contact an administrator to request the required role."
      buttonText="Back to login"
      to="/login"
    />
  )
}

export default Unauthorized
